import { Box, styled } from '@mui/material';
import { ImageFromFileStorage } from '@procureai/uix';

import { MAX_DIMENSION_PX } from './UserProfileCropDialog/UserProfileCropDialog.util';

export const FalconImageStyled = styled(ImageFromFileStorage)({
  position: 'absolute',
  width: MAX_DIMENSION_PX,
  height: MAX_DIMENSION_PX,
});

export const EditBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  width: '26px',
  height: '26px',
  top: '2px',
  right: '2px',
  padding: '1px',
  borderRadius: '1px',
  backgroundColor: 'rgba(255,255,255,0.80)',
  cursor: 'pointer',
});
